import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import { SectionHeading, EmptyState } from 'components/Erp/Presentation';
import { hasAccess, canViewDrivers } from 'utils/access'
import { useSelector } from 'react-redux'
import React, { useState } from 'react'
import ResponsiveTable from './ResponsiveTable'
import { MapPin, Map , Warehouse, Plus, Network, UsersRound, Truck, Pencil, Save, X, ChevronLeft, ChevronRight } from 'lucide-react'
import AuditButton from './AuditButton'
import styles from '../AdminPanelPage.module.scss'
import OperatorsList from './OperatorsList'
import DriversList from './DriversList'
import BranchesList from './BranchesList'
import MiniMap from 'pages/ReportCard/MiniMap'

const TopBasesPanel = ({
  topBasesFilter,
  setTopBasesFilter,
  filteredTopBases,
  topBasesPagination,
  loadTopBasesPage,
  openCreateModal,
  startEdit,
  editingTopBase,
  editPayloads,
  setEditPayloads,
  saveEdit,
  cancelEdit,
  expandedTopBase,
  setExpandedTopBase,
  expandedOperatorsTopBase,
  setExpandedOperatorsTopBase,
  expandedDriversTopBase,
  setExpandedDriversTopBase,
  expandedBranchesTopBase,
  setExpandedBranchesTopBase,
  loadOperatorsByTopBasePage,
  loadDriversByTopBasePage,
  loadBranchesByTopBasePage,
  operatorsByTopBase,
  driversByTopBase,
  branchesByTopBase,
  operatorsPaginationByTopBase,
  driversPaginationByTopBase,
  branchesPaginationByTopBase,
  operatorsFilterByTopBase,
  driversFilterByTopBase,
  branchesFilterByTopBase,
  setOperatorsFilterByTopBase,
  setDriversFilterByTopBase,
  setBranchesFilterByTopBase,
  employees,
  editingOperatorByTopBase,
  editingDriverByTopBase,
  editingBranchByTopBase,
  startEditOperator,
  startEditDriver,
  startEditBranch,
  saveEditOperator,
  saveEditDriver,
  saveEditBranch,
  cancelEditOperator,
  cancelEditDriver,
  cancelEditBranch,loadOperators,
  loadDriversByTopBase,
  expandedDriverByTopBase,
  toggleDriver,
  expandedOperatorByTopBase,
  toggleOperator,
  printDriverPass,
  downloadDriverPass,
  topBases,
  chpps = [],
  privatePoints = []
}) => {
  useInterfaceLanguage();
  const currentUser=useSelector(state=>state.user)
  const driversVisible = canViewDrivers(currentUser)
  const [visibleMaps, setVisibleMaps] = useState({})
  return (
    <div className={styles.panel}>
      <SectionHeading icon={Warehouse} title={tr("ТОП-базы")} actions={<><div>
          <button className={styles.addButton} onClick={() => openCreateModal('topbase')}><Plus size={14} aria-hidden="true"/>{tr(" Добавить ТОП-Базу")}</button>
        </div></>} />
      <div className={styles.panelBody}>
        <div className={styles.searchRow}>
          <input className={styles.searchInput} placeholder={tr("Поиск...")} value={topBasesFilter} onChange={(e) => setTopBasesFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadTopBasesPage(1, topBasesFilter) }} />
        </div>
        {filteredTopBases && filteredTopBases.length ? (
          <ResponsiveTable className={styles.table}>
            <thead>
              <tr>
                <th>№</th>
                <th>{tr("Название")}</th>
                <th>{tr("Телефон")}</th>
                <th>{tr("Местоположение")}</th>
                <th>{tr("Действия")}</th>
              </tr>
            </thead>
            <tbody>
              {filteredTopBases.map((tb, index) => (
                <React.Fragment key={tb.id}>
                  <tr className={styles.topBaseRow}>
                    <td>{tr(index + 1)}</td>
                    <td className={styles.topBaseTitle} onClick={() => { const newVal = (expandedTopBase === tb.id ? null : tb.id); setExpandedTopBase(newVal); if (newVal) loadOperatorsByTopBasePage(tb.id, 1); }}>{tr(tb.name)}</td>
                    <td>{tr(tb.phone || '-')}</td>
                    <td>
                      {tb.geo ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexDirection: 'column' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <button
                              onClick={() => window.open(`https://www.google.com/maps?q=${tb.geo}`, '_blank')}
                              className={styles.geoLinkBtn}
                              title={tr("Открыть в Google Maps")}
                            >
                              <Map size={13}/>{tr(" Карты")}</button>
                            <button
                              onClick={() => setVisibleMaps(previous => ({ ...previous, [tb.id]: !previous[tb.id] }))}
                              aria-expanded={!!visibleMaps[tb.id]}
                              aria-controls={`map-${tb.id}`}
                              className={styles.mapToggleBtn}
                              title={tr("Показать/скрыть карту")}
                            >
                              <MapPin size={13}/>
                            </button>
                          </div>
                          <div id={`map-${tb.id}`} style={{ width: 200, height: 150, display: visibleMaps[tb.id] ? 'block' : 'none' }}>
                            <MiniMap geo={tb.geo} />
                          </div>
                        </div>
                      ) : '-'}
                    </td>
                    <td>
                      <div className={styles.actionGroup}>
                        <button aria-expanded={expandedTopBase === tb.id && expandedBranchesTopBase === tb.id} className={`${styles.smallBtn} ${expandedTopBase === tb.id && expandedBranchesTopBase === tb.id ? styles.actionActive : ''}`} onClick={() => { const newVal = (expandedBranchesTopBase === tb.id ? null : tb.id); setExpandedBranchesTopBase(newVal); if (newVal) loadBranchesByTopBasePage(tb.id, 1); setExpandedTopBase(tb.id); }}><Network size={14} aria-hidden="true"/>{tr(" Филиалы")}</button>
                        <button aria-expanded={expandedTopBase === tb.id && expandedOperatorsTopBase === tb.id} className={`${styles.smallBtn} ${expandedTopBase === tb.id && expandedOperatorsTopBase === tb.id ? styles.actionActive : ''}`} onClick={() => { const newVal = (expandedOperatorsTopBase === tb.id ? null : tb.id); setExpandedOperatorsTopBase(newVal); if (newVal) loadOperatorsByTopBasePage(tb.id, 1); setExpandedTopBase(tb.id); }}><UsersRound size={14} aria-hidden="true"/>{tr(" Операторы")}</button>
                        {tr(driversVisible && <button aria-expanded={expandedTopBase === tb.id && expandedDriversTopBase === tb.id} className={`${styles.smallBtn} ${expandedTopBase === tb.id && expandedDriversTopBase === tb.id ? styles.actionActive : ''}`} onClick={() => { const newVal = (expandedDriversTopBase === tb.id ? null : tb.id); setExpandedDriversTopBase(newVal); if (newVal) loadDriversByTopBasePage(tb.id, 1); setExpandedTopBase(tb.id); }}><Truck size={14} aria-hidden="true"/>{tr(" Водители")}</button>)}
                        <button className={`${styles.smallBtn} ${styles.editBtn}`} onClick={() => startEdit('topbase', tb.id, { name: tb.name, phone: tb.phone })}><Pencil size={14} aria-hidden="true"/>{tr(" Изменить")}</button><AuditButton section="top_bases" objectId={tb.id} objectType="tabel.TopBase"/>
                      </div>
                    </td>
                  </tr>
                  {tr(editingTopBase === tb.id && (
                    <tr>
                      <td colSpan={5}>
                        <div style={{ padding: 8 }}>
                          <label>{tr("Название")}</label>
                          <input value={(editPayloads[`topbase__${tb.id}`] || {}).name || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`topbase__${tb.id}`]: { ...p[`topbase__${tb.id}`], name: e.target.value } }))} />
                          <label style={{ marginLeft: 8 }}>{tr("Телефон")}</label>
                          <input value={(editPayloads[`topbase__${tb.id}`] || {}).phone || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`topbase__${tb.id}`]: { ...p[`topbase__${tb.id}`], phone: e.target.value } }))} />
                          <div style={{ marginTop: 8 }} className={styles.navbattons}>
                            <button className={styles.btn_pin} onClick={() => saveEdit('topbase', tb.id)}><Save size={14} aria-hidden="true"/>{tr(" Сохранить")}</button>
                            <button className={styles.btn_pin_close} style={{ marginLeft: 8 }} onClick={() => cancelEdit('topbase', tb.id)}><X size={14} aria-hidden="true"/>{tr(" Отмена")}</button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {tr(expandedTopBase === tb.id && (
                    <tr>
                      <td colSpan={5}>
                        <div className={styles.operatorsList}>
                          {tr(expandedOperatorsTopBase === tb.id && (
                            <OperatorsList
                              tb={tb}
                              operators={operatorsByTopBase[tb.id]}
                              operatorsFilter={operatorsFilterByTopBase[tb.id]}
                              setOperatorsFilter={(v) => setOperatorsFilterByTopBase(prev => ({ ...prev, [tb.id]: v }))}
                              loadOperatorsByTopBasePage={loadOperatorsByTopBasePage}
                              employees={employees}
                              openCreateModal={openCreateModal}
                              editingOperatorByTopBase={editingOperatorByTopBase}
                              editPayloads={editPayloads}
                              setEditPayloads={setEditPayloads}
                              startEdit={startEditOperator}
                              saveEdit={saveEditOperator}
                              cancelEdit={cancelEditOperator}
                              operatorsPagination={operatorsPaginationByTopBase[tb.id]}
                              expandedOperatorByTopBase={expandedOperatorByTopBase}
                              toggleOperator={toggleOperator}
                            />
                          ))}

                          {tr(driversVisible && expandedDriversTopBase === tb.id && (
                            <DriversList
                              tb={tb}
                              drivers={driversByTopBase[tb.id]}
                              driversFilter={driversFilterByTopBase[tb.id]}
                              setDriversFilter={(v) => setDriversFilterByTopBase(prev => ({ ...prev, [tb.id]: v }))}
                              loadDriversByTopBasePage={loadDriversByTopBasePage}
                              employees={employees}
                              editingDriverByTopBase={editingDriverByTopBase}
                              editPayloads={editPayloads}
                              setEditPayloads={setEditPayloads}
                              startEdit={startEditDriver}
                              saveEdit={saveEditDriver}
                              openCreateModal={openCreateModal}
                              cancelEdit={cancelEditDriver}
                              driversPagination={driversPaginationByTopBase[tb.id]}
                              expandedDriverByTopBase={expandedDriverByTopBase}
                              toggleDriver={toggleDriver}
                              printDriverPass={printDriverPass}
                              downloadDriverPass={downloadDriverPass}
                              topBases={topBases}
                              chpps={chpps}
                              privatePoints={privatePoints}
                            />
                          ))}

                          {tr(expandedBranchesTopBase === tb.id && (
                            <BranchesList
                              base={tb}
                              baseType="ТОП-базы"
                              branches={branchesByTopBase[tb.id]}
                              branchesFilter={branchesFilterByTopBase[tb.id]}
                              setBranchesFilter={(v) => setBranchesFilterByTopBase(prev => ({ ...prev, [tb.id]: v }))}
                              loadBranchesByBasePage={loadBranchesByTopBasePage}
                              openCreateModal={openCreateModal}
                              editingBranch={editingBranchByTopBase}
                              editPayloads={editPayloads}
                              setEditPayloads={setEditPayloads}
                              startEdit={startEditBranch}
                              saveEdit={saveEditBranch}
                              cancelEdit={cancelEditBranch}
                              branchesPagination={branchesPaginationByTopBase[tb.id]}
                            />
                          ))}
                        </div>
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </ResponsiveTable>
        ) : (
          <EmptyState icon={Warehouse} title={tr("ТОП-базы не найдены")} description={tr("Добавьте базу или измените условия поиска.")} compact />
        )}
        {tr((!topBasesFilter && topBasesPagination && topBasesPagination.count > 0) && (
          <div className={styles.pagination}>
            <button disabled={!topBasesPagination.previous} onClick={() => loadTopBasesPage((topBasesPagination.page || 1) - 1)}><ChevronLeft size={14} aria-hidden="true"/>{tr(" Пред.")}</button>
            <span>{tr("Стр. ")}{tr(topBasesPagination.page || 1)}{tr(" — Всего: ")}{tr(topBasesPagination.count)}</span>
            <button disabled={!topBasesPagination.next} onClick={() => loadTopBasesPage((topBasesPagination.page || 1) + 1)}><ChevronRight size={14} aria-hidden="true"/>{tr(" След.")}</button>
          </div>
        ))}
      </div>
    </div>
  )
}

export default TopBasesPanel
